import { List, Radio, Space } from "antd";

import { PRESET_STAFF_ALERTS, describePresetAlert } from "../supportAlertConstants";
import { PresetPreview, StepContainer } from "./styles";

// Step 2 (add flow): choose how alerts are set up. Presets need an SMS-capable recipient; copy
// needs at least one recipient to copy from.
const AlertSourceStep = ({ userFlow, setUserFlow, validContactMethods, copyableRecipients }) => (
  <StepContainer>
    <div>
      <p>Step 2: Choose how to set up alerts for this recipient.</p>
    </div>
    <Radio.Group id="alert-source" value={userFlow} onChange={(e) => setUserFlow(e.target.value)}>
      <Space direction="vertical">
        <Radio value="customAlerts">Build custom alerts</Radio>
        <Radio value="usePresetAlerts" disabled={validContactMethods === "email"}>
          Use recommended preset alerts
        </Radio>
        <Radio value="copyExistingAlerts" disabled={copyableRecipients.length === 0}>
          Copy alerts from another recipient
        </Radio>
      </Space>
    </Radio.Group>
    {userFlow === "usePresetAlerts" && (
      <PresetPreview>
        <div>These preset alerts will be added:</div>
        <List
          size="small"
          dataSource={PRESET_STAFF_ALERTS}
          renderItem={(alertClass) => <List.Item>{describePresetAlert(alertClass)}</List.Item>}
        />
      </PresetPreview>
    )}
  </StepContainer>
);

export default AlertSourceStep;
